import { usePropsStore } from './goodStore/index';
import { useAddSell } from './addSellStore/index';
import { useShopStore } from './shopStore/index';
import { useorderList } from './orderListStore/index';
import { usePersonal } from './personalStore/index';
import { useSearchPage } from './searchStore/index';

export default function useStore(){
    return {
        allProps:usePropsStore(),
        addSellPinia:useAddSell(),
        shopStore:useShopStore(),
        orderListStore:useorderList(),
        personalStore:usePersonal(),
        searchStore:useSearchPage(),
    }
}